export interface Request {
  arrival: string;
  departure: string;
  flight: string;
  transfer: boolean;
  rentalCar: string;
  hotel: string;
  hotelBoard: string;
  persons: Person[];
  offerName: string;
  customerNumber: string;
  passportNumber: string;
  address: string;
  postcode: string;
  city: string;
  country: string;
  email: string;
  phone: string;
  comment: string
}
export interface Person {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  equipments: Equipment[];
  windsurfLessons: WindsurfLesson[];
  kitesurfLessons: KitesurfLesson[];
  wingfoilLessons: WingfoilLesson[];
  storages: Storage[]
}
export interface Equipment {
  type: string;
  beginn: string;
  duration: string;
  board: string;
  insurance: boolean;
  wetsuit: string;
  harness: string;
  helmet: string;
  lifeVest: string;
  doubleUse: string;
  partnerSpecial: string;
  privateRental: string
}
export interface WindsurfLesson {
  type: string;
  beginn: string;
  hourlyRental: string
}
export interface KitesurfLesson {
  type: string;
  beginn: string;
  groupSize: string;
  duration: string
}
export interface WingfoilLesson {
  type: string;
  beginn: string
}
export interface Storage {
  type: string;
  beginn: string
}
export const Airports = [
  "Aalborg | AAL | Denmark",
  "Aarhus | AAR | Denmark",
  "Aberdeen | ABZ | United Kingdom",
  "Adana | ADA | Turkey",
  "Ajaccio | AJA | France",
  "Ålesund | AES | Norway",
  "Alghero | AHO | Italy",
  "Alicante | ALC | Spain",
  "Allgäu Memmingen | FMM | Germany",
  "Almaty | ALA | Kazakhstan",
  "Almeria | LEI | Spain",
  "Amsterdam Schiphol | AMS | Netherlands",
  "Ancona | AOI | Italy",
  "Ankara Esenboga | ESB | Turkey",
  "Antalya | AYT | Turkey",
  "Antwerp | ANR | Belgium",
  "Astana | TSE | Kazakhstan",
  "Athens | ATH | Greece",
  "Baku | GYD | Azerbaijan",
  "Barcelona | BCN | Spain",
  "Bari | BRI | Italy",
  "Basel Mulhouse Freiburg | BSL, MLH, EAP | France",
  "Bastia | BIA | France",
  "Belfast City | BHD | United Kingdom",
  "Belfast International | BFS | United Kingdom",
  "Belgrade Nikola Tesla | BEG | Serbia",
  "Bergamo | BGY | Italy",
  "Bergen | BGO | Norway",
  "Bergerac | EGC | France",
  "Berlin Brandenburg | BER | Germany",
  "Berlin Schönefeld | SXF | Germany",
  "Berlin Tegel | TXL | Germany",
  "Bern | BRN | Switzerland",
  "Biarritz | BIQ | France",
  "Bilbao | BIO | Spain",
  "Billund | BLL | Denmark",
  "Birmingham | BHX | United Kingdom",
  "Bodø | BOO | Norway",
  "Bologna | BLQ | Italy",
  "Bordeaux | BOD | France",
  "Bratislava | BTS | Slovakia",
  "Bremen | BRE | Germany",
  "Brest Bretagne | BES | France",
  "Brindisi | BDS | Italy",
  "Bristol | BRS | United Kingdom",
  "Brno | BRQ | Czech Republic",
  "Brussels | BRU | Belgium",
  "Bucharest Henri Coanda | OTP | Romania",
  "Budapest | BUD | Hungary",
  "Burgas | BOJ | Bulgaria",
  "Cagliari | CAG | Italy",
  "Cardiff | CWL | United Kingdom",
  "Catania Fontanarossa | CTA | Italy",
  "Chania | CHQ | Greece",
  "Charleroi | CRL | Belgium",
  "Chisinau | KIV | Moldova",
  "Cluj-Napoca | CLJ | Romania",
  "Cologne Bonn | CGN | Germany",
  "Comiso | CIY | Italy",
  "Copenhagen | CPH | Denmark",
  "Corfu | CFU | Greece",
  "Cork | ORK | Ireland",
  "Dalaman | DLM | Turkey",
  "Debrecen | DEB | Hungary",
  "Dortmund | DTM | Germany",
  "Dresden | DRS | Germany",
  "Dublin | DUB | Ireland",
  "Dubrovnik | DBV | Croatia",
  "Düsseldorf | DUS | Germany",
  "East Midlands | EMA | United Kingdom",
  "Edinburgh | EDI | United Kingdom",
  "Eindhoven | EIN | Netherlands",
  "Faro | FAO | Portugal",
  "Figari South Corsica | FSC | France",
  "Florence | FLR | Italy",
  "Frankfurt | FRA | Germany",
  "Friedrichshafen | FDH | Germany",
  "Gdansk | GDN | Poland",
  "Genève | GVA | Switzerland",
  "Genoa | GOA | Italy",
  "Girona | GRO | Spain",
  "Glasgow | GLA | United Kingdom",
  "Glasgow Prestwick | PIK | United Kingdom",
  "Gothenburg Landvetter | GOT | Sweden",
  "Gran Canaria | LPA | Spain",
  "Graz | GRZ | Austria",
  "Groningen Eelde | GRQ | Netherlands",
  "Hahn | HHN | Germany",
  "Hamburg | HAM | Germany",
  "Hannover | HAJ | Germany",
  "Haugesund | HAU | Norway",
  "Helsinki Vantaa | HEL | Finland",
  "Heraklion | HER | Greece",
  "Humberside | HUY | United Kingdom",
  "Iasi | IAS | Romania",
  "Ibiza | IBZ | Spain",
  "Innsbruck | INN | Austria",
  "Ireland West Knock | NOC | Ireland",
  "Istanbul Atatürk | IST | Turkey",
  "Istanbul New | n/a | Turkey",
  "Istanbul Sabiha Gökcen | SAW | Turkey",
  "Izmir Adnan Menderes | ADB | Turkey",
  "Jerez | XRY | Spain",
  "Jersey | JER | United Kingdom",
  "Karlsruhe Baden-Baden | FKB | Germany",
  "Katowice | KTW | Poland",
  "Kaunas | KUN | Lithuania",
  "Keflavik | KEF | Iceland",
  "Kerry | KIR | Ireland",
  "Kiev Borispol | KBP | Ukraine",
  "Kiev Zhuliany | IEV | Ukraine",
  "Klagenfurt | KLU | Austria",
  "Koltsovo | SVX | Russia",
  "Kos | KGS | Greece",
  "Kraków | KRK | Poland",
  "Kristiansand | KRS | Norway",
  "Lamezia Terme | SUF | Italy",
  "Lanzarote | ACE | Spain",
  "Larnaca | LCA | Cyprus",
  "Leeds Bradford | LBA | United Kingdom",
  "Leipzig Halle | LEJ | Germany",
  "Liege | LGG | Belgium",
  "Lille | LIL | France",
  "Linz | LNZ | Austria",
  "Lisbon | LIS | Portugal",
  "Liverpool | LPL | United Kingdom",
  "Ljubljana | LJU | Slovenia",
  "London City | LCY | United Kingdom",
  "London Gatwick | LGW | United Kingdom",
  "London Heathrow | LHR | United Kingdom",
  "London Luton | LTN | United Kingdom",
  "London Southend | SEN | United Kingdom",
  "London Stansted | STN | United Kingdom",
  "Lugano | LUG | Switzerland",
  "Luxembourg | LUX | Luxembourg",
  "Lyon-Saint Exupéry | LYS | France",
  "Maastricht Aachen | MST | Netherlands",
  "Madeira | FNC | Portugal",
  "Madrid Barajas | MAD | Spain",
  "Malaga | AGP | Spain",
  "Mallorca | PMI | Spain",
  "Malmö | MMX | Sweden",
  "Malta | MLA | Malta",
  "Manchester | MAN | United Kingdom",
  "Marseille | MRS | France",
  "Menorca | MAH | Spain",
  "Milan Linate | LIN | Italy",
  "Milan Malpensa | MXP | Italy",
  "Milas-Bodrum | BJV | Turkey",
  "Minsk | MSQ | Belarus",
  "Modlin | WMI | Poland",
  "Montpellier | MPL | France",
  "Moscow Domodedovo | DME | Russia",
  "Moscow Sheremetyevo | SVO | Russia",
  "Moscow Vnukovo | VKO | Russia",
  "München | MUC | Germany",
  "Münster Osnabrück | FMO | Germany",
  "Murcia-San Javier | MJV | Spain",
  "Mykonos | JMK | Greece",
  "Nantes | NTE | France",
  "Naples | NAP | Italy",
  "Newcastle | NCL | United Kingdom",
  "Nice | NCE | France",
  "Niš | INI | Serbia",
  "Nürnberg | NUE | Germany",
  "Odessa | ODS | Ukraine",
  "Olbia Costa Smeralda | OLB | Italy",
  "Oslo Gardermoen | OSL | Norway",
  "Ostend Bruges | OST | Belgium",
  "Oulu | OUL | Finland",
  "Paderborn Lippstadt | PAD | Germany",
  "Palermo | PMO | Italy",
  "Paphos | PFO | Cyprus",
  "Paris Beauvais | BVA | France",
  "Paris Charles de Gaulle | CDG | France",
  "Paris Orly | ORY | France",
  "Perugia | PEG | Italy",
  "Pescara | PSR | Italy",
  "Pisa | PSA | Italy",
  "Podgorica | TGD | Montenegro",
  "Ponta Delgada | PDL | Portugal",
  "Porto | OPO | Portugal",
  "Poznan | POZ | Poland",
  "Prague | PRG | Czech Republic",
  "Pristina | PRN | Serbia",
  "Pula | PUY | Croatia",
  "Reus | REU | Spain",
  "Rhodos | RHO | Greece",
  "Riga | RIX | Latvia",
  "Rome Ciampino | CIA | Italy",
  "Rome Fiumicino | FCO | Italy",
  "Rotterdam The Hague | RTM | Netherlands",
  "Rovaniemi | RVN | Finland",
  "Saint Petersburg Pulkovo | LED | Russia",
  "Salzburg | SZG | Austria",
  "Sandefjord Torp | TRF | Norway",
  "Santander | SDR | Spain",
  "Santiago de Compostela | SCQ | Spain",
  "Santorini | JTR | Greece",
  "Sarajevo | SJJ | Bosnia and Herzegovina",
  "Seville | SVQ | Spain",
  "Shannon | SNN | Ireland",
  "Skopje | SKP | Macedonia",
  "Sochi | AER | Russia",
  "Sofia | SOF | Bulgaria",
  "Southampton | SOU | United Kingdom",
  "Split | SPU | Croatia",
  "Stavanger | SVG | Norway",
  "Stockholm Arlanda | ARN | Sweden",
  "Stockholm Bromma | BMA | Sweden",
  "Stockholm Skavsta | NYO | Sweden",
  "Stockholm Västerås | VST | Sweden",
  "Strasbourg | SXB | France",
  "Stuttgart | STR | Germany",
  "Tallinn | TLL | Estonia",
  "Tampere | TMP | Finland",
  "Tbilisi | TBS | Georgia",
  "Tenerife North | TFN | Spain",
  "Tenerife South | TFS | Spain",
  "Thessaloniki | SKG | Greece",
  "Timisoara | TSR | Romania",
  "Tirana | TIA | Albania",
  "Tivat | TIV | Montenegro",
  "Toulon-Hyères | TLN | France",
  "Toulouse Blagnac | TLS | France",
  "Trabzon | TZX | Turkey",
  "Trapani | TPS | Italy",
  "Treviso | TSF | Italy",
  "Tromsø | TOS | Norway",
  "Trondheim | TRD | Norway",
  "Turin | TRN | Italy",
  "Turku | TKU | Finland",
  "Tuzla | TZL | Bosnia and Herzegovina",
  "Vaasa | VAA | Finland",
  "Valencia | VLC | Spain",
  "Varna | VAR | Bulgaria",
  "Venice | VCE | Italy",
  "Verona | VRN | Italy",
  "Vienna | VIE | Austria",
  "Vilnius | VNO | Lithuania",
  "Warsaw | WAW | Poland",
  "Weeze | NRN | Germany",
  "Wroclaw | WRO | Poland",
  "Yerevan Zvartnots | EVN | Armenia",
  "Zadar | ZAD | Croatia",
  "Zagreb | ZAG | Croatia",
  "Zakynthos | ZTH | Greece",
  "Zaragoza | ZAZ | Spain",
  "Zürich | ZRH | Switzerland"
];
export const RentalCars = [
  "A = Seat Mii*",
  "B = Fiat 500*",
  "C = Peugeot 208*",
  "D = Renault Clio*",
  "E = Renault Megane*",
  "F = Opel Insignia*"
];
export const Hotels = [
  "Paradisus by Meliá Fuerteventura",
  "ZEL Fuerteventura 16+",
  "Sol Fuerteventura Jandía – All Suites"
];
export const HotelBoards = [
  "",
  "Half Board",
  "All Inclusive (only Meliá Fuerteventura)"
];
export const Countrys = [
  "DE",
  "GB",
  "ES",
  "FR",
  "PL",
  "AF",
  "AL",
  "DZ",
  "AS",
  "AD",
  "AO",
  "AI",
  "AQ",
  "AG",
  "AR",
  "AM",
  "AW",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CM",
  "CA",
  "CV",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "CI",
  "HR",
  "CU",
  "CY",
  "CZ",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GU",
  "GT",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IL",
  "IT",
  "JM",
  "JP",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "KR",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MK",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MH",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "FM",
  "MD",
  "MC",
  "MN",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MP",
  "NO",
  "OM",
  "PK",
  "PW",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PT",
  "PR",
  "QA",
  "RE",
  "RO",
  "RU",
  "RW",
  "SH",
  "KN",
  "LC",
  "PM",
  "VC",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "SC",
  "SL",
  "SG",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "LK",
  "SD",
  "SR",
  "SJ",
  "SZ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "VI",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "AX",
  "BQ",
  "CW",
  "GG",
  "IM",
  "JE",
  "ME",
  "BL",
  "MF",
  "RS",
  "SX",
  "SS",
  "XK"
];
export const EquipmentDurations = [
  "4 days",
  "5 days",
  "6 days",
  "7 days",
  "8 days",
  "9 days",
  "10 days",
  "11 days",
  "12 days",
  "13 days",
  "14 days",
  "15 days",
  "16 days",
  "17 days",
  "18 days",
  "19 days",
  "20 days",
  "21 days",
  "4/6 days",
  "9/13 days",
  "14/20 days"
];
export const EquipmentWingPremiumBoards = [
  "North - Seek 4'10'' | 57",
  "North - Seek 4'8'' | 68",
  "North - Seek 4'10'' | 78",
  "North - Seek 5'0'' | 88",
  "North - Seek 5'1'' | 98",
  "North - Seek 5'4'' | 108",
  "North - Seek 5'5'' | 118",
  "North - Seek 5'11'' | 138",
  "North - Swell 4'10'' | 41"
];
export const EquipmentWindsurfPremiumBoards = [
  "JP - Freestyle Wave PRO | 78",
  "JP - Freestyle Wave PRO | 84",
  "JP - Freestyle Wave PRO | 94",
  "JP - Freestyle Wave PRO | 104",
  "JP - Freestyle Wave PRO | 114",
  "JP - Freestyle PRO | 95",
  "JP - Freestyle PRO | 105",
  "STARBOARD - Ignite | 87",
  "STARBOARD - Ignite | 93",
  "STARBOARD - Ignite | 103",
  "STARBOARD - Futura | 100",
  "STARBOARD - Futura | 105",
  "STARBOARD - Futura  | 110",
  "STARBOARD - Futura | 120",
  "STARBOARD - iSonic | 123",
  "STARBOARD - iSonic | 129",
  "SEVERNE - Dyno | 75",
  "SEVERNE - Dyno | 85",
  "SEVERNE - Dyno | 95",
  "SEVERNE - Dyno | 105",
  "SEVERNE - Fox | 95",
  "SEVERNE - Fox | 105",
  "SEVERNE - Fox | 115",
  "SEVERNE - Fox | 125",
  "SEVERNE - Fox | 135"
];
export const EquipmentWindsurfWorldCupBoards = [
  "JP - Super Ride | 113",
  "JP - Super Ride | 124",
  "JP - Super Ride | 139",
  "JP - Magic Ride | 119",
  "JP - Magic Ride | 129",
  "JP - Magic Ride | 139",
  "JP - Magic Ride | 149",
  "JP - Magic Ride | 159",
  "STARBOARD - Kode | 85",
  "STARBOARD - Kode | 95",
  "STARBOARD - Kode | 105",
  "STARBOARD - Kode | 115",
  "STARBOARD - Futura | 100",
  "STARBOARD - Futura | 105",
  "STARBOARD - Futura | 110",
  "STARBOARD - Futura | 120",
  "STARBOARD - Futura | 135",
  "STARBOARD - Go | 133",
  "STARBOARD - Go | 144",
  "STARBOARD - Go | 155",
  "Severne Dyno HD | 85",
  "Severne Dyno HD | 95",
  "Severne Dyno HD | 105",
  "Severne Dyno HD | 115",
  "Severne Fox HD | 95",
  "Severne Fox HD | 105",
  "Severne Fox HD | 120",
  "Severne Fox HD | 140",
  "Severne Verso | 122",
  "Severne Verso | 138",
  "Severne Verso | 154"
];
export const EquipmentWindsurfKidsBoards = [
  "JP - Young Gun Magic Ride EVA | 112",
  "JP - Magic Ride EVA Family | 139",
  "JP - Magic Ride EVA Family | 149"
];
export const EquipmentKitesurfPremiumBoards = [
  "NORTH - Atmos Carbon | 136cm",
  "NORTH - Atmos Carbon | 138cm",
  "NORTH - Atmos Carbon | 141cm",
  "NORTH - Atmos Carbon | 144cm",
  "NORTH - Flare | 139cm",
  "NORTH - Flare | 143cm",
  "NORTH - Charge | 5'5''",
  "NORTH - Charge | 5'7''",
  "NORTH - Charge | 5'9''",
  "NORTH - Cross | 5'0''",
  "NORTH - Cross | 5'2''",
  "NORTH - Scoop  | 120cm",
  "NORTH - Sense | 135cm",
  "NORTH - Atmos Hybrid | 133cm",
  "NORTH - Atmos Hybrid | 136cm",
  "NORTH - Atmos Hybrid | 138cm",
  "NORTH - Atmos Hybrid | 141cm",
  "NORTH - Atmos Hybrid | 144cm",
  "NORTH - Prime | 136cm",
  "NORTH - Prime | 138cm",
  "NORTH - Prime | 141cm",
  "NORTH - Prime | 144cm",
  "NORTH - Prime | 148cm",
  "North Trace | 145",
  "North Trace | 155",
  "North Astra | 132",
  "North Astra | 135",
  "North Astra | 138"
];
